// Slice one page out of a list.
export const paginate = <T>(items: T[], page: number, perPage: number): T[] => {
  const startIndex = (page - 1) * perPage;
  const endIndex = startIndex + perPage;
  return items.slice(startIndex, endIndex);
};

// Page numbers to render, with 'ellipsis' markers where the sequence jumps.
export const pageWindow = (totalPages: number, currentPage: number): Array<number | 'ellipsis'> => {
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1).filter((page) => {
    // Show first page, last page, current page, and pages around current
    return page === 1 || page === totalPages || Math.abs(page - currentPage) <= 1;
  });

  const window: Array<number | 'ellipsis'> = [];
  pages.forEach((page, index) => {
    // Add ellipsis if there's a gap
    const showEllipsisBefore = index > 0 && page - pages[index - 1] > 1;
    if (showEllipsisBefore) {
      window.push('ellipsis');
    }
    window.push(page);
  });
  return window;
};
